import { motion, useAnimation } from "framer-motion";
import { useEffect, useState, useCallback } from "react";

function MagnetizeButton({
  children,
  onClick,
  particleCount = 12,
  style = {},
}) {
  const [isAttracting, setIsAttracting] = useState(false);
  const [particles, setParticles] = useState([]);
  const particlesControl = useAnimation();

  useEffect(() => {
    const newParticles = Array.from({ length: particleCount }, (_, i) => ({
      id: i,
      x: Math.random() * 360 - 180,
      y: Math.random() * 360 - 180,
    }));
    setParticles(newParticles);
  }, [particleCount]);

  const handleInteractionStart = useCallback(async () => {
    setIsAttracting(true);
    await particlesControl.start({
      x: 0,
      y: 0,
      transition: { type: "spring", stiffness: 50, damping: 10 },
    });
  }, [particlesControl]);

  const handleInteractionEnd = useCallback(async () => {
    setIsAttracting(false);
    await particlesControl.start((i) => ({
      x: particles[i]?.x ?? 0,
      y: particles[i]?.y ?? 0,
      transition: { type: "spring", stiffness: 100, damping: 15 },
    }));
  }, [particlesControl, particles]);

  return (
    <button
      onClick={onClick}
      onMouseEnter={handleInteractionStart}
      onMouseLeave={handleInteractionEnd}
      onTouchStart={handleInteractionStart}
      onTouchEnd={handleInteractionEnd}
      style={{
        position: "relative",
        overflow: "visible",
        touchAction: "none",
        background: "linear-gradient(135deg,#4E6C7E,#6C969C)",
        color: "#fff",
        border: "none",
        padding: "13px 30px",
        borderRadius: 10,
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        fontSize: 14,
        fontWeight: 600,
        cursor: "pointer",
        letterSpacing: "-0.01em",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        transform: isAttracting ? "translateY(-2px)" : "translateY(0)",
        transition: "transform 0.2s, box-shadow 0.2s, background 0.2s",
        boxShadow: isAttracting
          ? "0 8px 28px rgba(78,108,126,0.45)"
          : "0 2px 8px rgba(78,108,126,0.25)",
        ...style,
      }}
    >
      {particles.map((_, index) => (
        <motion.div
          key={index}
          custom={index}
          initial={{ x: particles[index]?.x ?? 0, y: particles[index]?.y ?? 0 }}
          animate={particlesControl}
          style={{
            position: "absolute",
            width: 7,
            height: 7,
            borderRadius: "50%",
            background: isAttracting ? "rgba(232,241,243,0.95)" : "rgba(108,150,156,0.55)",
            opacity: isAttracting ? 1 : 0.5,
            pointerEvents: "none",
            transition: "opacity 0.3s, background 0.3s",
          }}
        />
      ))}
      <span style={{ position: "relative", zIndex: 1 }}>{children}</span>
    </button>
  );
}

export { MagnetizeButton };
